import utils from '../utils';
import events from 'events-bus';
import CONSTANTS from '../lib/constants';

let CART = {};
let previousVal;

const updateQuantityIcon = (counter) => {
  const parent = counter.parent();
  const counterQuantity = parent.attr('data-counter-quantity');

  if (typeof counterQuantity === 'undefined' || counterQuantity === false)
    return;

  const binIcon =
    '<svg class="checkout__icon" aria-hidden="true"><use xlink:href="#bin"></use></svg>';
  const minusMidIcon =
    '<svg class="checkout__icon" aria-hidden="true"><use xlink:href="#minus-mid"></use></svg>';

  const input = parent.children('input[name="articleCount"]');
  const inputVal = parseInt(input.val(), 10);
  const leftIcon = parent.find('button').first().find('i');

  parent.attr('data-counter-quantity', inputVal);

  if (inputVal === 0 || inputVal === 1) {
    leftIcon.html(binIcon);
  } else if (inputVal > 1) {
    leftIcon.html(minusMidIcon);
  }
};

CART.init = function () {
  let timer = null;
  $('.js-inc-amount').on('click', function () {
    let form = $(this).closest('form');
    let input = $(this).prev('input[name="articleCount"]');
    if (input.length > 0 && form.length > 0) {
      let value = input.val();
      if (!value) {
        value = input.attr('data-initial-value');
      }
      input.val(parseInt(value) + 1);

      updateQuantityIcon($(this));

      if (timer) {
        clearTimeout(timer); // cancel the previous timer.
        timer = null;
      }
      timer = setTimeout(function () {
        form.find('.loading__view').addClass('loading');
        utils.adobeTrackingCall(form, input, 'add');
      }, 1000);
    }
  });

  $('.js-dec-amount').on('click', function () {
    let form = $(this).closest('form');
    let input = $(this).next('input[name="articleCount"]');

    if (input.length > 0 && form.length > 0) {
      let value = input.val();
      if (!value) {
        value = input.attr('data-initial-value');
      }
      input.val(parseInt(value) - 1);
      if (input.val() < 0) {
        input.val(0);
      }

      updateQuantityIcon($(this));

      if (timer) {
        clearTimeout(timer); // cancel the previous timer to prevent the form submit.
        timer = null;
      }

      timer = setTimeout(function () {
        form.find('.loading__view').addClass('loading');
        utils.adobeTrackingCall(form, input, 'remove');
      }, 1000);
    }
  });

  $('button.js-remove__btn')
    .show()
    .bind('click', function (event) {
      event.preventDefault();

      let form = $(this).closest('form');
      let input = form.find('input[name=articleCount]');
      let select = form.find('select[name=articleCount]');

      if (input.length > 0) {
        input.val(0); // set quantity to 0 and submit form
        utils.adobeTrackingCall(form, input, 'remove');
      } else if (select.length > 0) {
        select.val(0); // set quantity to 0 for select elements e.g. configurable Items
        utils.adobeTrackingCall(form, select, 'remove');
      }
    });

  const select = $('select[name="articleCount"]');
  select.focus(function () {
    previousVal = $(this).val();
  });

  select.change(function () {
    let form = $(this).closest('form');
    let currentVal = $(this).val();
    if (previousVal > currentVal) {
      utils.adobeTrackingCall(form, select, 'remove');
    } else {
      utils.adobeTrackingCall(form, select, 'add');
    }
  });
  initCartServiceEvents();
};

function initCartServiceEvents() {
  events.on(CONSTANTS.CART_SERVICE_ADD_TO_CART_SUCCESS, () => {
    location.reload();
  });
}

export default CART;
